// MOSTLY obsolete.
// Functions left should move elsewhere!

import React from 'react';

export function CopyTextToClipboard(event, text) {
    // TODO perhaps do this a more modern/react way...
    var textField = document.createElement('textarea');
    textField.innerText = text;
    var parentElement = document.body;
    parentElement.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    parentElement.removeChild(textField);

    let div = document.createElement('div');
    const top = event.pageY - 15
    const left = event.pageX
    div.innerHTML = '<div class="copied-to-clipboard" style="position: absolute; z-index: 100000; top: '+top+'px; left: '+left+'px;">Copied!</div>';
    document.body.appendChild(div);
    setTimeout(function() { document.body.removeChild(div) }, 750);
}

export function GncFilePathLink(path) {
    if( typeof path === 'undefined' || path == '' ) {
        return '';
    } else if( path.match(/^http/i) ) {
        return (<a href={path} target="_blank" data-tooltip-id="gnctooltip" data-tooltip-content="Open Document" rel="noreferrer"><i className="fa fa-file-o"></i></a>)
    } else {
        path = path.replace(/\\/g, '\\\\') // Need to quote backslashes before putting them into live javascript
        return (<a onClick={(e) => { e.preventDefault(); CopyTextToClipboard(e, path)}} data-tooltip-id="gnctooltip" data-tooltip-content="Copy Filepath to Clipboard"><i className="fa fa-copy"></i></a>)
    }
}

// WE have to use this to handle when user opens in new tab etc. Fucked up.
// But we can't seem to put a <Link> inside DataTables. Fucked up x2

// Update on this
// We _can_ use the useTableSlots. So that works across the board.
// But Portfolio needs some extra functionality, icon and shit.
// So just need to build that into the linkSlot.
// TODO -- do this!
export function GncLink(navigate, url, linkText, callback, opts) {
    if( ! opts ) {
        opts = {}
    }
    return (
        <span>
            <a href={url} onClick={(e) => {
                    // ctrl+click for normal users
                    if(e.ctrlKey) return;
                    // ctrl+click for mac users
                    if(e.metaKey) return;
                    
                    e.preventDefault();
                    callback();
                    navigate(url)}}
            >
                {opts.noWrap
                 ? <span className="no-wrap">{linkText}</span>
                 : linkText
                }
            </a>
            {opts.icon
             ? <i className={opts.icon.className}
                  data-tooltip-id="gnctooltip"
                  data-tooltip-html={opts.icon.dataTip}></i>
             : null
            }
        </span>
    )
}

export function PortfolioUrl(location) {
    let url = '/portfolio'
    let currentPathname = location.pathname
    let queryString = ''
    
    let knownProjectContexts = [
        'dashboard',
        'information',
        'customer_documents',
        'documents',
        'included_documents',
        'records',
        'delivery_lists',
        'reports',
        'action_items',
        'action_item_sources'
    ]
    knownProjectContexts.forEach(function (context) {
        if (currentPathname.includes('/' + context)) {
            queryString = '?project_context=' + context
            return
        }
    })
    
    if( queryString == '' ) {
        queryString = '?other_context=' + currentPathname
    }
    url += queryString
    return url
}
